import * as React from 'react';
import AngleRight from '../components/AngleRight';
import Layout from '../components/Layout';
import SeePost from '../components/SeePost';
import ViewOpenRoles from '../components/ViewOpenRoles';
import styled from 'styled-components';
import { extractNode } from '../utils/extractNode';
import { graphql, Link } from 'gatsby';
import SocialMedia from '../components/SocialMedia';

import CupLeaves from '../images/careers/CupLeaves.svg';
import Downtown from '../images/careers/Downtown.svg';
import FourHands from '../images/careers/FourHands.svg';
import HandsHeart from '../images/careers/HandsHeart.svg';
import Mind from '../images/careers/Mind.svg';
import PiggyBank from '../images/careers/PiggyBank.svg';
import RecyleDollar from '../images/careers/RecyleDollar.svg';
import Star from '../images/careers/Star.svg';
import Trophy from '../images/careers/Trophy.svg';
import Typing from '../images/careers/Typing.svg';
import lightBulbManWoman from '../images/careers/lightBulbManWoman.png';
import radialGradient from '../images/radialShadow.jpg';

import careersHeaderPhotoWithGradient from '../images/careers/jeromeMisun629x417.jpg';

import ReactPlayer from 'react-player';

const Section = styled.section`

	&.centered-text {
		margin-top: 2em;
	}

	&.life-at-mk h3 {
		@media (${(props) => props.theme.largeUp}) {
			max-width: 980px;
		}
	}

	&.four-pillars h3 {
		@media (${(props) => props.theme.largeUp}) {
			max-width: 560px;
		}
	}

	&.two-rounded-boxes {
		align-items: stretch;
		padding-top: 0;
		padding-bottom: 0;

		& .rounded-box {
			max-width: 320px;
			margin-left: auto;
			margin-right: auto;

			@media (${(props) => props.theme.largeUp}) {
				max-width: 550px;
			}
		}

		& header {
			align-items: flex-end;
		}

		& article {
			display: flex;
			align-items: stretch;
		}
	}

	&.ready-to-produce {
		padding: 0;
		margin: 0 0 4em 0;

		@media (${(props) => props.theme.mediumUp}) {
			margin-top: 5em;
		}

		& .black {
			background: black;
			color: white;
			min-height: 125px;
		}

		& .centeredWrapper {
			max-width: 1366px;
			width: 100%;
		}

		& article {
			padding-left: ${(props) => props.theme.paddingMediumUp};
			padding-right: ${(props) => props.theme.paddingMediumUp};
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-around;
			min-height: 340px;
			padding-bottom: 130px;

			@media (${(props) => props.theme.mediumUp}) {
				align-items: center;
				padding-bottom: 0;
				min-height: 125px;
				justify-content: space-between;
			}

			& h2 {
				text-align: center;
				max-width: 280px;

				@media (${(props) => props.theme.smallUp}) {
					max-width: 350px;
				}

				@media (${(props) => props.theme.mediumUp}) {
					max-width: 250px;
					text-align: left;
				}

				@media (${(props) => props.theme.largeUp}) {
					max-width: 350px;
				}
			}

			@media (${(props) => props.theme.mediumUp}) {
				flex-direction: row;
				justify-content: space-between;
			}
		}

		& figure {
			display: flex;
			justify-content: center;
			margin-top: -95px;

			@media (${(props) => props.theme.mediumUp}) {
				margin-top: -225px;
			}
		}
	}

	&.perks-and-benefits {
		article.grid {
			padding-top: 3em;
			display: grid;

			/* ie11 fallback */
			@media all and (-ms-high-contrast: none) {
				display: flex;
				flex-wrap: wrap;

				& .rounded-box {
					width: 32%;

					& h3 {
						max-width: 90%;
					}

					& p {
						max-width: 90%;
					}
				}
			}

			@media (${(props) => props.theme.mediumUp}) {
				grid-template-columns: 330px 330px;
				grid-template-rows: 1fr 1fr 1fr;
				justify-content: space-between;
			}

			@media (${(props) => props.theme.largeUp}) {
				grid-template-columns: 275px 275px 275px;
				grid-template-rows:  1fr 1fr;
				column-gap: 10px;
			}

			@media (${(props) => props.theme.xLargeUp}) {
				grid-template-columns: 330px 330px 330px;
				grid-template-rows:  1fr 1fr;
				column-gap: 10px;
			}

			& .rounded-box {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				align-items: center;

				max-width: 320px;
				margin-right: auto;
				margin-left: auto;

				@media (${(props) => props.theme.mediumUp}) {
					max-width: 275px;
					margin-left: 0;
					margin-roght: 0;
				}

				@media (${(props) => props.theme.xLargeUp}) {
					max-width: 330px;
				}

				& figure {
					min-height: 120px;
					display: flex;
					align-items: center;

					& svg {
						margin: 0;
					}
				}

				& h3 {
					font-size: 21px;
					margin-top: 0.5em;
					// min-height: 50px;
				}

				& p {
					text-align: center;
				}
			}
		}
	}

	&.ready-to-make {
		padding-bottom: 0;
	}

	&.open-positions {
		& h3 {
			margin-bottom: 2.5em;
		}

		& .positions-list {
			text-align: left;
			// display: flex;
			// justify-content: space-between;
			// flex-wrap: wrap;

			& h2 {
				margin-bottom: .5em;
			}

			@media (${(props) => props.theme.xLargeUp}) {
				// flex-wrap: nowrap;
				& article.dept {
					padding-left: 0;
					padding-right: 0;
				}
			}
		}

		& ul {
			padding-left: 0;
			list-style: none;
			margin-bottom: 2em;
			& li {
				margin-bottom: 1em;
			}
		}
	}

	&.video {
		& iframe {
			width: 100%;
		}
		& .player-wrapper {
			position: relative;
			padding-top: 56.25%;
		}
		&  iframe {
			position: absolute;
			top: 0;
			left: 0;
		}
	}

	&.thumbnails {

		& article.grid {
			display: grid;
			grid-template-columns: 1fr 1fr;
			// grid-template-rows: 1fr 1fr 1fr;
			justify-items: end;
			justify-content: space-between;
			margin-bottom: 2em;
			grid-template-columns: 1fr 1fr;
			// grid-template-rows: 1fr 1fr 1fr;
			column-gap: 10px;
			row-gap: 10px;

			@media (${(props) => props.theme.mediumUp}) {
				grid-template-columns: 1fr 1fr 1fr;
				// grid-template-rows: 1fr 1fr;
			}

			/* ie11 fallback */
			@media all and (-ms-high-contrast: none) {
				display: flex;
				flex-wrap: wrap;

				& figure {
					width: 32%;
				}
			}
		}

		& aside {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;

			@media (${(props) => props.theme.mediumUp}) {
				flex-direction: row;
			}

			& .socialMedia {
				max-width: 204px;
				width: 100%;
				display: flex;
				justify-content: space-between;
				margin-bottom: 2em;

				@media (${(props) => props.theme.mediumUp}) {
					margin-bottom: 0;
				}
			}
		}
	}
`;

const ThumbnailFigure = styled.figure`
	background-color: grey;
	background-image: ${(props) => `url('${props.thumbnailBackground}')`};
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	width: 100%;
	margin: 0;
	min-height: 150px;
	min-width: 150px;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;

	@media (${(props) => props.theme.mediumUp}) {
		min-height: 250px;
	}

	@media (${(props) => props.theme.largeUp}) {
		min-height: 350px;
	}

	& figcaption {
		& a.animate-right {
			color: white;
			padding: 2em 1em 1em 1em;
			text-shadow: 0px 0px 2px black;
			display: block;
			width: 100%;
			height: 100%;
		}
	}
}
`;

const RadialGradient = styled.div`
@media (${(props) => props.theme.mediumUp}) {
	background-image: ${(props) => `url('${radialGradient}')`};
	background-size: 100% 100%;
	background-position: center center;
	max-width: 1366px;
	margin-left: auto;
	margin-right: auto;
	padding: 0;
}
`;

const HeaderContentArticle = styled.article`
	color: white;

	& h1 {
		line-height: 1.2;
		margin-bottom: 1em;

		@media (${(props) => props.theme.mediumUp}) {
			width: 500px;
		}
	}

	p {
		font-size: 20px;
		line-height: 1.2;
		margin-bottom: 2em;
	}

	&.careers {

		@media (${(props) => props.theme.mediumUp}) {

			& .viewOpenRoles {
				max-width: 350px;
			}
		}

		@media (${(props) => props.theme.largeUp}) {

			padding-top: 2em;

			& h1 {
				font-size: 50px;
				line-height: 58px;
				margin-bottom: 0.5em;
			}

			& p {
				font-size: 30px;
				line-height: 36px;
				margin-bottom: 1em;
			}
		}
	}

`;

const keyFeaturesHeaderContentArticle =
	<HeaderContentArticle className='careers'>
		<h1>Help us <br className='hide-sm-down' />make <br className='hide-md-up' />lending simple</h1>
		<p>Join the team at MK Decision<br />as we transform digital lending.</p>
		<ViewOpenRoles />
	</HeaderContentArticle>
;

const CareersIndex = (props: any) => {

	const positionList = [] as any;
	const positions = props.data.positions.edges.map(extractNode);
	positions.forEach((position: any) => {
		if (!positionList.find((category: any) => category.name === position.category)) {
			positionList.push({ name: position.category });
		}
	});

	positionList.sort((a: any, b: any) => a.name.localeCompare(b.name));
	positionList.forEach((category: any) => {
		const categoryPositions = positions.filter((position: any) => position.category === category.name);
		categoryPositions.sort((a: any, b: any) => a.title.localeCompare(b.title));
		category.positions = categoryPositions;
	});

	const igList = [] as any;
	const igNodes = props.data.allInstaNode.edges.map(extractNode);
	let maxIgPosts = igNodes.length;
	if (maxIgPosts > 3) {
		maxIgPosts = 3;
	}
	const igPostPreIdSLug =  'https://www.instagram.com/p/';

	for (let i = 0; i < maxIgPosts; i++){
		let postUrl = igPostPreIdSLug;
		postUrl += igNodes[i].id;
		postUrl += '/';
		igNodes[i].url = postUrl;
		igList.push(igNodes[i]);
	}

	return (
	<Layout
		headerSplashBg={careersHeaderPhotoWithGradient}
		headerSplashBgPosition={'right top'}
		headerSplashBgPositionLarge={'right center'}
		headerSplashBgSizeLarge={'auto 100%'}
		CenteredSplashWrapperClass='jeromeMisun'
		headerContent={keyFeaturesHeaderContentArticle}
		headerSplashBgAverageColor={'#3596d1'}
		metaDescription={'MK Decision is Hiring! Check out Job Openings at MK, a FinTech startup in San Diego, California'}
		pageTitle='Careers in San Diego'
		skipMoney2020={true}
		skipUseCases={true}
		BodyClass={'careers'}
	>
		<div className='centeredWrapper'>
			<Section className='centered-text life-at-mk'>
				<h2>Life at MK Decision</h2>
				<h3>The people of MK share a passion for innovation, individual responsibility, and growth in their craft. We work collaboratively to achieve our goals as a team.</h3>
			</Section>
			<Section className='video'>
				<figure>
					<div className='player-wrapper'>
						<ReactPlayer
							url='https://www.youtube.com/watch?v=Uq4vZGoKcog?rel=0'
							controls={true}
							height='100%'
							width='100%'
						/>
					</div>
				</figure>
			</Section>
			<Section className='thumbnails'>
				<article className='grid'>
					{igList.map((igPost: any) => <ThumbnailFigure
						key={igPost.id}
						thumbnailBackground={igPost.localFile.childImageSharp.fixed.src}
					>
						<SeePost
							url={igPost.url}
							title={igPost.caption}
						/>
					</ThumbnailFigure>)}
				</article>
				<aside>
					<SocialMedia svgFillColor={'#000'} />
					<ViewOpenRoles />
				</aside>
			</Section>
			<RadialGradient>
				<Section className='centered-text four-pillars'>
					<h2>Our four pillars</h2>
					<h3>MK's company culture is based on four pillars that structure our business practices.</h3>
				</Section>
				<Section className='two-rounded-boxes row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Mind alt='open mind' />
								<h2>Open<br />your mind</h2>
							</header>
							<p>Think big. Embrace change. Challenge the status quo. At MK, our competitive advantage is the bright minds of our team, thinking outside the box with a common goal.</p>
						</div>
					</article>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Star alt='star' />
								<h2>Do the<br />right thing</h2>
							</header>
							<p>Treat everyone equally with respect and professionalism. At MK, these values apply to our work product and environment; ensuring integrity in our products and dignity in our personnel.</p>
						</div>
					</article>
				</Section>
				<Section className='two-rounded-boxes row row-flush centered'>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Typing alt='keyboard' />
								<h2>Do whatever<br />it takes</h2>
							</header>
							<p>Daily life at MK is built around going the extra mile to achieve greatness. No matter what it takes, we go above and beyond to exceed client expectations. Excellence is our way of life.</p>
						</div>
					</article>
					<article className='col-12 col-md-6'>
						<div className='rounded-box left-aligned'>
							<header>
								<Trophy alt='trophy' />
								<h2>Win<br />together</h2>
							</header>
							<p>In a society driven by competition, MK takes a team approach to winning. Together Everyone Achieves More. Like the great philosopher Aristotle said, “The whole is greater than the sum of its parts.”</p>
						</div>
					</article>
				</Section>
			</RadialGradient>
		</div>
		<Section className='full-width ready-to-produce'>
			<div className='black'>
				<div className='centeredWrapper'>
					<article>
						<h2>Ready to produce the best work of your career with MK&nbsp;Decision?</h2>
						<ViewOpenRoles />
					</article>
				</div>
			</div>
			<figure>
				<img src={lightBulbManWoman} alt='man and woman brainstorming' />
			</figure>
		</Section>
		<div className='centeredWrapper'>
			<RadialGradient>
				<Section className='centered-text perks-and-benefits'>
					<h2>Benefits and perks</h2>
					<h3>Team up with dynamic software engineers, innovative product managers and designers to create the new standard in loan origination.</h3>
					<article className='grid'>
						<div className='rounded-box'>
							<figure>
								<FourHands alt='four hands' />
							</figure>
							<h3>Team Environment</h3>
							<p>Collaboration is key as our goals are too big to achieve as individuals.</p>
						</div>
						<div className='rounded-box'>
							<figure>
								<PiggyBank alt='piggy bank' />
							</figure>
							<h3>Quarterly Compensation Reviews</h3>
							<p>Performance reviews are a two-way street. They allow managers and employees to exchange ideas to better the company.</p>
						</div>
						<div className='rounded-box'>
							<figure>
								<Downtown alt='San Diego Skyline' />
							</figure>
							<h3>Downtown San Diego</h3>
							<p>Centrally located in sunny San Diego, MK's HQ offers skyline and ocean views.</p>
						</div>
						<div className='rounded-box'>
							<figure>
								<RecyleDollar alt='Dollar reimbursement' />
							</figure>
							<h3>Parking reimbursement</h3>
							<p>Parking is a pain. Paying for parking is a financial drain. We cover the cost.</p>
						</div>
						<div className='rounded-box'>
							<figure>
								<CupLeaves alt='coffee cup' />
							</figure>
							<h3>Free food &amp; snacks</h3>
							<p>Stocked break room with coffee and snacks. Catered lunches every Friday!</p>
						</div>
						<div className='rounded-box'>
							<figure>
								<HandsHeart alt='healthcare heart' />
							</figure>
							<h3>Healthcare Benefits</h3>
							<p>Healthy life = happy life. Leverage MK's health, vision, and dental plans.</p>
						</div>
					</article>
				</Section>
				<Section className='centered-text ready-to-make'>
					<h2>Ready to make a difference with MK Decision?</h2>
				</Section>
			</RadialGradient>
			<Section id='open-roles' className='centered-text open-positions'>
				<h2 className='openPositions'>Open Positions</h2>
				<h3>Want to jump start your career in finance techology? Join our supportive culture, designed to help people become their greatest selves.</h3>
				<div className='positions-list row row-flush'>
					{positionList.map((category: any) => <article className='dept col-12 col-md-6' key={category.name}>
						<h2>{category.name}</h2>
						<ul>
							{category.positions.map((position: any) => <li key={position.positionId}>
								<Link
									to={`/${position.positionId}/`}
									className={`animate-right viewPosition ${position.positionId}`}
								>
									{position.title}
									<AngleRight smallMarginLeft={true} />
								</Link>
							</li>)}
						</ul>
					</article>)}
				</div>
			</Section>
		</div>
	</Layout>
	);
};

export const query = graphql`
	query PositionListing {
		positions: allPositionsJson {
			edges {
				node {
					category
					positionId
					title
				}
			}
		}

		site: site {
			siteMetadata {
				endpoint
			}
		}

		allInstaNode (
			sort: {
			  fields: timestamp,
			  order:DESC
			},
			limit: 3
		  ) {
			edges {
			  node {
				id
				caption
				localFile {
					childImageSharp {
					  fixed(width: 770, height: 700) {
						...GatsbyImageSharpFixed
					  }
					}
				}
			  }
			}
		}
	}
`;

export default CareersIndex;
